import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'

export default () => {
    const map = useMapContext()
    const {mapTypeCode, prjId, sVer} = map.data

    if ('SA_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = () => openWindow('/BdDtCompleteList', {prjId, sVer})

    return {
        label: '库表补全',
        onClick,
    }
}
